import { constraints, blocks } from '@yola/ws-sdk';
import matchBlockElement from '../../common/helpers/match-block-element';
import isElementListItemInCustomBlock from '../../blocks/helpers/is-element-list-item-in-custom-block';

const COLUMN_IN_WIDGET_SELECTOR = 'ws-block[widget="columns"] ws-column';

const isColumnInWidget = (element) =>
  Boolean(element && element.matches(COLUMN_IN_WIDGET_SELECTOR));

const getClosestInteractiveOnHoverElement = (sourceElement) => {
  if (!sourceElement) {
    return null;
  }

  let element = sourceElement;

  while (element) {
    const isInteractable = constraints.verifiers.canBeInteracted(element);
    const isSelectable = constraints.verifiers.canBeSelected(element);

    if (
      (isInteractable && !isSelectable && !matchBlockElement(element)) ||
      isColumnInWidget(element) ||
      blocks.verifiers.isWidgetElement(element, 'columns')
    ) {
      return element;
    }

    const columnAncestor = element.closest(COLUMN_IN_WIDGET_SELECTOR);

    if (isInteractable && columnAncestor) {
      if (isElementListItemInCustomBlock(element)) {
        return element;
      }

      if (element.parentElement === columnAncestor && isSelectable) {
        return columnAncestor;
      }
    }

    element = element.parentElement;
  }

  return element;
};

export default getClosestInteractiveOnHoverElement;
